"use client";

import Link from "next/link";
import { DrupalNode } from "next-drupal";
import { motion } from "framer-motion";
import { FaGlobe, FaBullhorn, FaStore } from "react-icons/fa6";
import { config } from "@/lib/config";
import MemberCountrySlider from "@/components/sections/MemberCountrySlider";
import PartnerCardPagination from "@/components/sections/PartnerCardPagination";
import Banner from "@/components/sections/Banner";

const dummyCardsData = [
  {
    id: 1,
    title: "Global Ambition Taskforces",
    link: "/taskforce",
    description: "Driving stronger commitments to double energy efficiency",
    icon: FaGlobe,
  },
  {
    id: 2,
    title: "Narrative Taskforces",
    link: "/narrative-taskforce",
    description:
      "Shaping the story that makes energy efficiency a global priority",
    icon: FaBullhorn,
  },
  {
    id: 3,
    title: "Marketplace Taskforces",
    link: "/marketplace-taskforce",
    description: "Turning ambition into bankable projects and real investments",
    icon: FaStore,
  },
];

type GetInvolvedScreenProps = {
  data: DrupalNode;
  joinMissionData: DrupalNode;
  countryCards: DrupalNode[];
};

const GetInvolvedScreen: React.FC<GetInvolvedScreenProps> = ({
  data,
  countryCards,
}) => {
  const {
    field_join_mission_eff_title = "",
    field_role_eff_title = "",
    field_join_mission_eff_content = "",
    field_taskforce_title = "",
    field_taskforce_sub_title = "",
    field_roles_mission_efficiency = [],
    field_get_involved_options = [],
    field_task = [],
    field_get_involve_energy = [],
    field_me_partners_cards = [],
    field_me_partners_title = "",
    field_me_partners_subtitle = "",
    field_me_member_section_title = "",
    field_me_member_subtitle = "",
  } = data;

  console.log(countryCards, "countryCards")
  return (
    <div className="pt-20 bg-white box-border">
      <Banner
        title={"Get Involved"}
        isRounded
        backgroundImg="/static/images/get-involved.svg"
      />
      <div className="pb-[50px] bg-mapGray mobileMax:py-8">
        <div className="py-12 mobileMax:py-4">
          <div className="mini-container">
            <motion.h3
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0,
              }}
              className="remove-animation-fluctuation font-semibold text-numans mb-5 desktop:leading-[85px] bg-[linear-gradient(to_top,#8EBCE5,#11375C)] text-clip text-[48px] leading-normal mobileMax:text-[35px] mobileMax:mb-3 text-center"
            >
              {field_join_mission_eff_title}
            </motion.h3>
            <motion.p
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0,
              }}
              className="remove-animation-fluctuation --font-poppins text-medium leading-8 text-[#11375C] mobileMax:w-full mobileMax:text-small mobileMax:mb-6 mobileMax:leading-normal text-center"
            >
              {field_join_mission_eff_content}
            </motion.p>
          </div>
        </div>
        <div className="relative pt-16 mobileMax:pt-4">
          <div className="mini-container relative z-[2]">
            <motion.h3
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0,
              }}
              className="remove-animation-fluctuation font-semibold text-numans mb-5 desktop:leading-[85px] text-center bg-[linear-gradient(to_top,#8EBCE5,#11375C)] text-clip text-[48px] leading-normal mobileMax:text-[35px] mobileMax:mb-3"
            >
              {field_role_eff_title}
            </motion.h3>
            <div className="flex flex-wrap justify-start box-border mt-12 mobileMax:mt-6">
              {field_roles_mission_efficiency?.map(
                (joinCard: DrupalNode, index: number) => {
                  return (
                    <motion.div
                      key={index}
                      className="remove-animation-fluctuation  px-[6px] mb-[10px] w-[25%] mobileMax:mb-3 mobileMax:w-full mobileMax:px-0 lieTablets:w-[50%]"
                      initial={{ opacity: 0, y: 40 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{
                        duration: 0,
                      }}
                    >
                      <div className="border-2 border-transparent hover:border-[#11375C] transition rounded-xl bg-white h-full flex items-center flex-col box-border w-full card-shadow py-5 px-4">
                        <div className="h-full w-full">
                          <h4 className="text-numans text-center text-[22px] mb-3 text-[#11375C] leading-7 mobileMax:text-medium mobileMax:leading-7">
                            {joinCard?.title}
                          </h4>
                          <div
                            className="--font-poppins text-center text-small text-[#828282] leading-6 mobileMax:text-xsmall mobileMax:leading-normal font-normal"
                            dangerouslySetInnerHTML={{
                              __html: joinCard?.field_content.value,
                            }}
                          />
                        </div>
                      </div>
                    </motion.div>
                  );
                },
              )}
            </div>
            {/* <div className="flex flex-wrap justify-start box-border mt-12 mobileMax:mt-6">
              {field_get_involved_options?.map(
                (dropdownCard: DrupalNode, index: number) => {
                  return (
                    <motion.div
                      key={index}
                      className="remove-animation-fluctuation px-[15px] mb-[25px] w-[33%] mobileMax:w-full mt-2 mobileMax:px-0 lieTablets:w-[50%] mobileMax:mb-5 mobileMax:mt-0"
                      initial={{ opacity: 0, y: 40 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{
                        duration: 0,
                      }}
                    >
                      <div className="relative rounded-xl bg-white flex items-center border-2 border-[#ececec] flex-col box-border w-full card-shadow">
                        <h4 className="w-full flex items-center justify-center h-[100px] px-[15px] text-numans uppercase text-center text-[22px] bg-[linear-gradient(to_top,#8EBCE5,#11375C)] leading-normal mobileMax:text-medium font-semibold text-clip">
                          {dropdownCard.title}
                        </h4>
                        <div
                          className={`absolute bottom-[-15px] ${
                            isOpenJoinCardList === index ? "z-[99]" : "z-[1]"
                          } left-1/2 -translate-x-1/2`}
                        >
                          <motion.div
                            animate={
                              isOpenJoinCardList === index
                                ? { x: 0, y: 0 }
                                : { x: 0, y: [-5, 5, -5] }
                            }
                            viewport={{ once: true }}
                            transition={
                              isOpenJoinCardList === index
                                ? {}
                                : {
                                    duration: 2,
                                    ease: "easeInOut" as const,
                                    repeat: Infinity,
                                  }
                            }
                            className="cursor-pointer card-shadow bg-[linear-gradient(to_top,#8EBCE5,#11375C)] text-white w-[35px] h-[35px] rounded-full flex items-center justify-center"
                            onClick={() =>
                              setIsOpenJoinCardList(
                                isOpenJoinCardList === index ? null : index,
                              )
                            }
                          >
                            {isOpenJoinCardList === index ? (
                              <FaAngleUp className="text-[20px]" />
                            ) : (
                              <FaAngleDown className="text-[20px]" />
                            )}
                          </motion.div>
                        </div>
                        {isOpenJoinCardList === index && (
                          <motion.div className="list p-5 w-full absolute z-[4] card-shadow left-0 top-[103%] border-2 border-[#ececec] bg-white rounded-xl">
                            <motion.ul
                              initial="hidden"
                              animate="visible"
                              variants={listVariant}
                              className="pl-3 blue-bullets"
                            >
                              <motion.li variants={itemVariant}>
                                <p
                                  className="cursor-pointer underline text-left select-none block --font-poppins text-[18px] mb-3 leading-normal text-[#545d6f] mobileMax:w-full mobileMax:text-xsmall mobileMax:leading-normal"
                                  dangerouslySetInnerHTML={{
                                    __html: dropdownCard?.field_content?.value,
                                  }}
                                />
                              </motion.li>
                            </motion.ul>
                          </motion.div>
                        )}
                      </div>
                    </motion.div>
                  );
                },
              )}
            </div> */}
            <div
              className={`betweenMobileTab:py-16 mobileMax:py-10 relative py-[60px]`}
            >
              <div className="mini-container relative z-[2]">
                <motion.h3
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{
                    duration: 0,
                  }}
                  className="remove-animation-fluctuation font-semibold text-numans mb-5 desktop:leading-[85px] text-center bg-[linear-gradient(to_top,#8EBCE5,#11375C)] text-clip text-[48px] leading-normal mobileMax:text-[35px] mobileMax:mb-3"
                >
                  How to Join Mission Efficiency
                </motion.h3>
                <div className="flex flex-wrap justify-center box-border lieTablets:justify-start mt-[20px]">
                  {dummyCardsData.map((card) => {
                    return (
                      <Link
                        key={card.id}
                        href={card.link}
                        className="cursor-pointer px-[15px] mobileMax:px-0 mt-[30px] w-[33%] lieTablets:w-[50%] mobileMax:w-full tab:hover:scale-105 transition-all duration-700 flex-shrink-0"
                      >
                        <motion.div
                          className="relative flex flex-col h-[280px] rounded-[15px] border border-transparent hover:border-[#48DBB2]/30 shadow-[0_4px_20px_rgb(0,0,0,0.1)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.2)] hover:-translate-y-1 transition-all duration-500 overflow-hidden group bg-[linear-gradient(to_bottom_right,#1f6e9e,#11375C)]"
                          initial={{ opacity: 0, y: 40 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true }}
                          transition={{
                            duration: 0,
                            border: {
                              duration: 1.8,
                              ease: "easeInOut",
                            },
                          }}
                        >
                          {/* Abstract ambient glowing background corners */}
                          <div className="absolute -top-12 -right-12 w-64 h-64 bg-[#48DBB2] rounded-full blur-[55px] opacity-20 group-hover:opacity-40 group-hover:scale-125 transition-all duration-1000 z-0"></div>
                          <div className="absolute -bottom-12 -left-12 w-64 h-64 bg-[#8EBCE5] rounded-full blur-[55px] opacity-20 group-hover:opacity-40 group-hover:scale-125 transition-all duration-1000 z-0"></div>
                          {/* Faint dotted grid overlay */}
                          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+CjxjaXJjbGUgY3g9IjEiIGN5PSIxIiByPSIyIiBmaWxsPSJyZ2JhKDI1NSwyNTUsMjU1LDAuMjUpIi8+Cjwvc3ZnPg==')] [mask-image:linear-gradient(to_bottom,black,transparent)] opacity-70 z-0"></div>

                          <div className="relative z-20 flex-1 flex flex-col items-center justify-center p-8 text-center">
                            <card.icon className="text-white text-[45px] mb-4 opacity-80 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500 drop-shadow-md" />
                            <h3 className="text-white font-numans font-semibold text-[26px] leading-snug drop-shadow-[0_4px_10px_rgba(0,0,0,0.8)] group-hover:scale-105 transition-transform duration-500 mb-3">
                              {card.title}
                            </h3>
                            <p className="text-white/90 text-[15px] leading-relaxed drop-shadow-sm font-medium">
                              {card.description}
                            </p>
                          </div>
                        </motion.div>
                      </Link>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="taskforces" className="bg-graybg">
        <div className="pt-0">
          {/* <div className="mini-container">
            <motion.h3
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0,
              }}
              className="remove-animation-fluctuation mt-[82px] font-semibold text-numans mb-5 desktop:leading-[85px] bg-[linear-gradient(to_top,#8EBCE5,#11375C)] text-clip text-[48px] leading-normal mobileMax:text-[35px] mobileMax:mb-3 text-center"
            >
              {field_taskforce_title}
            </motion.h3>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0,
              }}
              className="remove-animation-fluctuation  --font-poppins mb-10 text-medium leading-8 text-[#11375C] mobileMax:w-full mobileMax:text-small mobileMax:mb-6 mobileMax:leading-normal text-center"
            >
              {field_taskforce_sub_title}
            </motion.div>
          </div>
           <div className="mini-container">
            <div className="mb-10 pb-10 mobileMax:py-6">
              {field_task?.map((testimonialCard: DrupalNode, index: number) => {
                return (
                  <motion.div
                    initial={{ opacity: 0, y: 60 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{
                      duration: 0,
                    }}
                    key={index}
                    className="remove-animation-fluctuation bg-white p-5 rounded-lg card-shadow relative mb-3"
                  >
                    <div>
                      <motion.h3 className="text-[35px] text-center text-numans mb-5 leading-normal text-clip bg-[linear-gradient(to_top,#8EBCE5,#11375C)] mobileMax:text-[28px] mobileMax:mb-3">
                        {testimonialCard.title}
                      </motion.h3>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: testimonialCard?.field_testi_content.value,
                        }}
                        className="mt-5 --font-poppins text-medium text-[#003350] mobileMax:text-xsmall leading-normal text-center"
                      />
                    </div>
                    <motion.div className="mt-5">
                      <motion.div className="py-3 px-5 flex flex-col justify-start mobileMax:px-0">
                        <motion.h5 className="h-full mb-5 text-clip bg-[linear-gradient(to_top,#8EBCE5,#11375C)] tracking-tight text-[35px] leading-normal text-center text-numans mobileMax:text-[28px]">
                          {testimonialCard?.field_testi_sub_ttitle}
                        </motion.h5>
                        {testimonialCard?.field_testi_description && (
                          <motion.div
                            className="elevate-list-view !text-[#003350] text-medium leading-normal --font-poppins mobileMax:text-small"
                            dangerouslySetInnerHTML={{
                              __html:
                                testimonialCard.field_testi_description
                                  .processed,
                            }}
                          />
                        )}
                        <div>
                          <div
                            className={`flex flex-row justify-between mobileMax:flex-col ${
                              testimonialCard?.field_first_link_text &&
                              "my-10 mobileMax:my-2"
                            }`}
                          >
                            {testimonialCard?.field_first_link_text && (
                              <Link
                                href={
                                  testimonialCard?.field_first_link_url || "#"
                                }
                                className="--font-poppins mobileMax:mt-2 text-medium text-[#2F6CA4] leading-6 flex items-center cursor-pointer  mobileMax:text-xsmall"
                              >
                                {testimonialCard?.field_first_link_text}
                                <MdChevronRight className="w-[18px] h-[18px] max-w-[18px] ml-0.5" />
                              </Link>
                            )}
                            {testimonialCard?.field_second_link_text && (
                              <Link
                                href={
                                  testimonialCard?.field_second_link_url || "#"
                                }
                                className="--font-poppins mobileMax:mt-5 text-medium text-[#2F6CA4] leading-6 flex items-center cursor-pointer  mobileMax:text-xsmall"
                              >
                                {testimonialCard?.field_second_link_text}
                                <MdChevronRight className="w-[18px] h-[18px] max-w-[18px] ml-0.5" />
                              </Link>
                            )}
                          </div>
                          <div className="w-full flex items-center justify-between mx-auto pt-10 mobileMax:flex-col">
                            {testimonialCard?.field_testimonial_image && (
                              <div className="max-w-[220px] min-w-[220px] mobileMax:min-w-[150px] mobileMax:max-w-[150px] mr-5 mobileMax:mr-0">
                                <Image
                                  src={`${config.apiBase}${
                                    testimonialCard?.field_testimonial_image
                                      ?.uri?.url || "#"
                                  }`}
                                  alt="country flag"
                                  width={100}
                                  unoptimized={true}
                                  height={100}
                                  className="w-full h-full min-h-[200px] max-w-[200px] mobileMax:min-h-[150px] mobileMax:max-h-[150px] mobileMax:min-w-[150px] mobileMax:max-w-[150px] rounded-full overflow-hidden object-cover object-center border-2 border-blueBorder mx-auto"
                                />
                              </div>
                            )}
                            {testimonialCard?.field_testimonial_content
                              ?.value && (
                              <div className="w-[80%]">
                                <p
                                  className="--font-poppins font-medium text-xmedium leading-snug italic text-center text-[#828282] my-8 resources-links mobileMax:text-xsmall mobileMax:leading-normal relative quotes-imgBox z-[2] w-[95%] tab:ml-auto"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      testimonialCard?.field_testimonial_content
                                        ?.value,
                                  }}
                                />
                              </div>
                            )}
                          </div>
                          {testimonialCard?.field_testimonial_name && (
                            <h6 className="text-numans text-right font-semibold text-[22px] uppercase italic history-title-gradient text-clip mobileMax:text-xsmall leading-normal pr-2 m-0">
                              - {testimonialCard?.field_testimonial_name}
                            </h6>
                          )}
                          {testimonialCard?.field_testimonial_designation && (
                            <p className="text-right pr-2 --font-poppins font-medium text-small text-[#828282] italic">
                              ({testimonialCard?.field_testimonial_designation})
                            </p>
                          )}
                        </div>
                      </motion.div>
                    </motion.div>
                  </motion.div>
                );
              })}
            </div>
          </div> */}
          {/* join section */}
          {field_get_involve_energy?.map(
            (bannerCard: DrupalNode, index: number) => {
              return (
                <div
                  key={index}
                  id="energy-efficient-life"
                  className="py-[82px] involved-efficient-life-banner relative"
                  style={{
                    backgroundImage: `url(${config.apiBase + bannerCard?.field_image_icon?.uri?.url
                      })`,
                  }}
                >
                  <div className="absolute top-0 left-0 bg-blackDarkOpacity h-full w-full" />
                  <div className="mini-container relative z-[2]">
                    <motion.h3
                      initial={{ opacity: 0, y: 40 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{
                        duration: 0,
                      }}
                      className="remove-animation-fluctuation font-bold desktop:text-[55px] text-numans min-h-[125px] mobileMax:min-h-[60px] desktop:leading-[85px] text-white text-[48px] leading-normal mobileMax:text-[35px] mobileMax:mb-4 text-center"
                    >
                      {bannerCard?.title}
                    </motion.h3>
                    <motion.div
                      initial={{ opacity: 0, y: 40 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{
                        duration: 0,
                      }}
                      className="remove-animation-fluctuation --font-poppins mb-12 text-xmedium leading-8 text-white mobileMax:w-full mobileMax:text-xsmall mobileMax:mb-6 mobileMax:leading-normal text-center"
                      dangerouslySetInnerHTML={{
                        __html: bannerCard?.field_content.value,
                      }}
                    />
                    <motion.div
                      initial={{ opacity: 0, y: 35 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{
                        duration: 0,
                      }}
                      className="flex justify-center remove-animation-fluctuation"
                    >
                      <Link
                        href={bannerCard?.field_link || "#"}
                        className="flex justify-center items-center get-involve-btn bg-[linear-gradient(to_right,#316FA8,#003350)] font-mediums text-white text-medium mobileMax:text-[16px] capitalize min-h-[55px] rounded-lg min-w-[180px]"
                      >
                        {bannerCard?.field_button_text}
                      </Link>
                    </motion.div>
                  </div>
                </div>
              );
            },
          )}
          {/* partners cards */}
          <div
            id="mission-efficiency-partners"
            className="overflow-hidden pt-[10px] pb-10 bg-mapGray mobileMax:pb-8 relative"
          >
            <div className=" relative z-[2]">
              <motion.h3
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0,
                }}
                className="mt-[82px] remove-animation-fluctuation font-semibold text-numans mb-5 desktop:leading-[85px] text-center bg-[linear-gradient(to_top,#8EBCE5,#11375C)] text-clip text-[48px] leading-normal mobileMax:text-[35px] mobileMax:mb-3"
              >
                {field_me_partners_title}
              </motion.h3>
              <motion.p
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0,
                }}
                className="remove-animation-fluctuation text-cardHeading mb-[60px] text-[24px] text-center mobileMax:mb-8 mobileMax:text-small leading-normal"
              >
                {field_me_partners_subtitle}
              </motion.p>
              <div className="mb-10 pb-10 mobileMax:py-6">
                <PartnerCardPagination
                  sliderData={field_me_partners_cards?.sort((a: any, b: any) =>
                    a.title.localeCompare(b.title),
                  )}
                />
              </div>
            </div>
          </div>
          {/* countries cards */}
          {!!countryCards?.length && (
            <div
              id="countries"
              className="pt-[60px] pb-10 bg-mapGray mobileMax:py-8"
            >
              <div className="">
                <motion.h3
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{
                    duration: 0,
                  }}
                  className="remove-animation-fluctuation desktop:text-[55px] text-numans mb-5 desktop:leading-[85px] text-center category-gradient text-clip text-[48px] leading-normal mobileMax:text-[35px] mobileMax:mb-3"
                >
                  {field_me_member_section_title}
                </motion.h3>
                <motion.p
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{
                    duration: 0,
                  }}
                  className="remove-animation-fluctuation text-cardHeading mb-[60px] text-[24px] text-center mobileMax:mb-8 mobileMax:text-small leading-normal"
                >
                  {field_me_member_subtitle}
                </motion.p>
                <div className="mb-10 pb-10 mobileMax:py-6">
                  <MemberCountrySlider
                    sliderData={countryCards?.sort((a: any, b: any) =>
                      a.title.localeCompare(b.title),
                    )}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GetInvolvedScreen;
